import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  skeletonContainer: {
    borderRadius: 0,
  },
  skeleton: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: 16,
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  link: {
    display: 'block',
  },
});

export default useStyles;
